import React, { useContext } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const shopLink = {
  rozetka:
    'https://rozetka.com.ua/ua/sigareti/c4638591/filter/producer=chesterfield;soderganie-smoli=4-mg,6-mg;tolshchina139079=kompakt-demi/?utm_source=PMUsmsCheCmpct',
  cigPoshta:
    'https://cig-poshta.in.ua/shop/chesterfield-ua/swoof/format-kompaktnyj-format/tarnist-4-and-5-and-6/?utm_source=CDAsmsCheCmpct'
};

const HomeScreen = () => {
  const { sendEvent } = useContext(DataLayerEventContext);

  return (
    <div className={styles.container}>
      <div
        className={styles.content}
        style={{
          backgroundImage: `url(${getImageFromS3(
            'images/sms-che-cmpct/bg.png'
          )})`
        }}
      >
        <div className={styles.characteristicContainer}>
          <div className={styles.characteristicItem}>
            <p style={{ marginLeft: 7 }}>6 мг</p>
            <p className={styles.characteristicName}>вміст смол</p>
            <p style={{ marginRight: 7 }}>4 мг</p>
          </div>
          <div
            className={styles.characteristicItem}
            style={{ marginTop: '5px' }}
          >
            <p>0.5 мг</p>
            <p className={styles.characteristicName}>вміст нікотину</p>
            <p>0.4 мг</p>
          </div>
        </div>
        <div className={styles.disclaimer}>
          *зазначено задекларовану максимальну роздрібну ціну з урахуванням
          акцизного податку на роздрібний продаж тютюнових виробів станом на
          квітень 2025 року
        </div>
        <div className={styles.characteristicImageContainer}>
          <div className={styles.itemContainer}>
            <img
              src={getImageFromS3('images/sms-che-cmpct/filter.png')}
              alt="filter"
            />
            <p>
              Повітряний <b>Recessed™</b> фільтр
            </p>
          </div>
          <div className={styles.itemContainer}>
            <img
              src={getImageFromS3('images/sms-che-cmpct/tobacco.png')}
              alt="tobacco"
            />
            <p>
              Бленд з <b>трьох сортів</b> тютюну
            </p>
          </div>
          <div className={styles.itemContainer}>
            <img
              src={getImageFromS3('images/sms-che-cmpct/format.png')}
              alt="format"
            />
            <p>
              <b>King Size Slims</b> компактний формат
            </p>
          </div>
        </div>
        <div className={styles.buyContainer}>
          <p className={styles.title}>Де купити</p>
          <p className={styles.subTitle}>
            <b>Chesterfield Compact Blue</b> та{' '}
            <b>Chesterfield Compact Silver</b> можна знайти у роздрібних точках
            продажу в твоєму місті або на офіційних онлайн сервісах, зокрема:
          </p>
          <div className={styles.buttonContainer}>
            <button
              onClick={() => {
                sendEvent('rozetka');
                window.open(shopLink.rozetka, '_blank');
              }}
            >
              Rozetka
            </button>
            <button
              onClick={() => {
                sendEvent('cig-poshta');
                window.open(shopLink.cigPoshta, '_blank');
              }}
            >
              Cig-poshta
            </button>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) лист, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-che-cmpct">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
